import { styled } from "@material-ui/core";

export const StandardIconMenuSeparator = styled("div")({
  justifyContent: "space-between",
  alignItems: "center",
  display: "flex",
  width: "100%",
});
